import styled from 'styled-components';
import {Resolution} from '../../const';

export const DesktopWrapper = styled.div`
	@media (max-width: ${Resolution.SM}) {
		display: none;
	}
`;
